const S4 = function() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
};
export function guid() {
    return (S4() + S4() +'' +S4() +'' +S4() +'' +S4() +'' +S4() +S4() +S4());
}
export const CalcTextWidth = (text, font = 'normal 14px \'pingfang SC\',\'helvetica neue\',arial,\'hiragino sans gb\',\'microsoft yahei ui\',\'microsoft yahei\',simsun,sans-serif') => {
    let canvas = CalcTextWidth.canvas || (CalcTextWidth.canvas = document.createElement('canvas'))
    let context = canvas.getContext('2d')
    context.font = font
    let metrics = context.measureText(text)
    return metrics.width
}